<script setup>
import IconsIconLoading from '@/Components/ui/icons/IconLoading.vue'
import { computed } from 'vue'

const props = defineProps({
	buttonMode: {
		type: String,
		default: 'light',
		required: false,
		validator: (value) =>
			['light', 'dark', 'gray', 'green', 'none'].includes(value),
	},
	buttonRadius: {
		type: String,
		default: 'full',
		required: false,
		validator: (value) => ['full', 'small'].includes(value),
	},
	additionalClasses: {
		type: String,
		default: '',
		required: false,
	},
	isMobileFullWidth: {
		type: Boolean,
		default: true,
		required: false,
	},
	isDisabled: {
		type: Boolean,
		default: false,
		required: false,
	},
	showLoader: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const emit = defineEmits(['click'])

const buttonClass = computed(() => {
	switch (props.buttonMode) {
		case 'dark':
			return 'button-dark'
		case 'gray':
			return 'button-gray'
		case 'green':
			return 'button-green'
		case 'none':
			return 'button-none'
		default:
			return 'button-white'
	}
})

const buttonRadiusClass = computed(() => {
	switch (props.buttonRadius) {
		case 'full':
			return 'rounded-full'
		case 'small':
			return 'rounded'
		default:
			return 'rounded-full'
	}
})

function onClick() {
	emit('click')
}
</script>

<template>
	<button
		v-bind="$attrs"
		class="relative flex items-center justify-center leading-tight lg:w-fit py-3"
		:class="[
			buttonClass,
			buttonRadiusClass,
			additionalClasses,
			isMobileFullWidth ? 'w-full lg:min-w-[110px] ' : 'min-w-[110px]',
			isDisabled
				? 'pointer-events-none cursor-default bg-gray-500'
				: 'cursor-pointer',
		]"
		:disabled="isDisabled"
		@click="onClick"
	>
		<div
			v-if="isDisabled && showLoader"
			class="absolute left-1/2 top-1/2 flex h-4 w-4 -translate-x-1/2 -translate-y-1/2 justify-center align-middle"
		>
			<IconsIconLoading />
		</div>

		<slot />
	</button>
</template>
